<table class="table">
  <tbody>
    <tr>
      <td>Category</td>
      <td>{{ class.category.name }}</td>
    </tr>
    <tr>
      <td>Description</td>
      <td>{{ class.description }}</td>
    </tr>
    <tr>
      <td>Type</td>
      <td>{{ formattedType }}</td>
    </tr>
    <tr>
      <td>Entry Type</td>
      <td>{{ formattedEntryType }}</td>
    </tr>
    <tr>
      <td>Age</td>
      <td>{{ formattedMinAge }}</td>
    </tr>
    <tr>
      <td>Opens</td>
      <td>{{ formattedState }}</td>
    </tr>
    @if (class.starts) {
      <tr>
        <td>Starts</td>
        <td><date-time [date]="class.starts" [includeTime]="true"></date-time></td>
      </tr>
    }
    @if (class.ends) {
      <tr>
        <td>Ends</td>
        <td><date-time [date]="class.ends" [includeTime]="true"></date-time></td>
      </tr>
    }
    @if (class.terms) {
      <tr>
        <td>Terms</td>
        <td>{{ class.terms }}</td>
      </tr>
    }
    <tr>
      <td>Entry cost</td>
      <td><client-currency [value]="class.amount"></client-currency></td>
    </tr>
    <tr>
      <td>Class Capacity</td>
      <td>
        @if(class.total_entries >= class.max_entries) {
          <span [ngStyle]="{ color: '#FF0000' }">Full</span>
        } @else {
          <span [ngStyle]="{ color: '#008000' }">{{ class.max_entries - class.total_entries }} places remaining</span>
        }
      </td>
    </tr>
    @if (isLoggedIn && systemConfigService.config.maxCapacity !== null && currentTotalCapacity !== null) {
      <tr>
        <td>Total Capacity</td>
        <td>
           @if(currentTotalCapacity >= systemConfigService.config.maxCapacity) {
             <span [ngStyle]="{ color: '#FF0000' }">Full</span>
           } @else {
             <span [ngStyle]="{ color: '#008000' }">{{ systemConfigService.config.maxCapacity - currentTotalCapacity }} places remaining</span>
           }
        </td>
      </tr>
    }
    <tr>
      <td>Closes</td>
      <td><date-time [date]="class.bookings_close" [includeTime]="true"></date-time></td>
    </tr>
  </tbody>
</table>
